import { Question } from "./question";

export interface SenseiStep {
  playtestQuestions: Question[];
  validationChecklist: string[];
  feedbackItems: Question[];
}
